import { render } from "./MesPresente.vue?vue&type=template&id=3dde4bd1&scoped=true"
import script from "./MesPresente.vue?vue&type=script&lang=js"
export * from "./MesPresente.vue?vue&type=script&lang=js"

import "./MesPresente.vue?vue&type=style&index=0&id=3dde4bd1&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dde4bd1"]])

export default __exports__